import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

const FormikCheckbox = (props, { error, helperText, style }) => {
    return (
        <Field style={style} variant="outlined" {...props} error={error}>
            {({ field: { name, value }, form: { setFieldValue } }) => {
                const onChange = (event) => {
                    setFieldValue(name, event.target.checked);
                };
                return (
                    <Checkbox
                        label={props.label || name}
                        value={value}
                        onChange={onChange}
                    />
                );
            }}
        </Field>
    );
};

export default FormikCheckbox;

FormikCheckbox.propTypes = {
    error: PropTypes.string,
    helperText: PropTypes.string,
    style: PropTypes.any,
};

FormikCheckbox.defaultProps = {
    error: null,
    helperText: null,
    value: false,
};
